import React from 'react'
import { List, Datagrid, TextField, ShowButton, EditButton, ReferenceField } from 'react-admin'
import ListPagination from '../../components/ListPagination'
import ConfirmBulkActions from '../../components/ConfirmBulkActions'
import { perPage } from '../../defaults/Defaults'

const PanelList = (props) => {
   
    return (
        <List 
            {...props}
            bulkActionButtons={<ConfirmBulkActions />}
            perPage={perPage}
            pagination={<ListPagination />}
            title="Panel">
            <Datagrid>
                <TextField source="uid" />
                <TextField source="access_code" />
                <TextField source="installer_code" />
                <ReferenceField label="Organization" source="org_id" reference="organizations" link="show">
                    <TextField source="name" />
                </ReferenceField>
                <TextField source="notes" />
                <ShowButton />
                <EditButton />
            </Datagrid>
        </List>
    );
}

export default PanelList;